/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, Input, TemplateRef} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {AppSharedModule} from '../app-shared.module';
import template from './signal-admin-resource-list.component.html';
import type {
  SignalAdminListColumn,
  SignalAdminResourceListViewState
} from './signal-admin-resource-list-state';
import type {SignalAdminResourceModel} from './signal-admin-resource-api';

@Component({
  standalone: true,
  selector: 'adn-signal-admin-resource-list',
  imports: [AppSharedModule, FormsModule, TranslateModule],
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignalAdminResourceListComponent {
  @Input() state: SignalAdminResourceListViewState<SignalAdminResourceModel>;
  @Input() columns: SignalAdminListColumn[];
  @Input() emptyMessage: string;
  @Input() loadErrorMessage: string;
  @Input() rowTemplate: TemplateRef<any>;
  @Input() detailRowTemplate: TemplateRef<any>;
  @Input() rowClass: (item: SignalAdminResourceModel) => string | string[] | Record<string, boolean>;
  @Input() enableBulkSelection = true;
  @Input() showExpandColumn = false;
  @Input() showObjectStateFilter = true;
  @Input() enableSearch = false;
  @Input() customBulkActionHolder = false;
}
